module.exports = __webpack_public_path__ + "static/media/logo1.ca13fac1.png";